<div class="app-wrapper">
    <p-toast position="bottom-right"></p-toast>
    <ls-header [hideNavigation]="po != null || vendorIdForLogs != null"></ls-header>
    <div class="main-content-outer" [class.no-padding]="useNoPadding">
        <div *ngIf="po != null" class="po"><ls-purchase-order (hide)="po = null"></ls-purchase-order></div>
        <div *ngIf="vendorIdForLogs != null" class="logs"><ls-log-list [vendorId]="vendorIdForLogs" (hide)="vendorIdForLogs = null"></ls-log-list></div>
        <div [hidden]="po != null || vendorIdForLogs != null" class="main-content-inner">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<p-confirmDialog></p-confirmDialog>
<p-confirmDialog key="okOnly" [rejectVisible]="false" acceptLabel="OK" [closable]="false" [closeOnEscape]="false"></p-confirmDialog>
<p-confirmPopup key="popup"></p-confirmPopup>
<p-confirmDialog
    #cd
    key="vendorIncomplete"
    acceptVisible="false"
    rejectVisible="false"
    >
    <ng-template pTemplate="message" let-message>
        <div style="display: flex; flex-direction: column; gap: 6px">
            <div style="display: flex; align-items: center; gap: 4px">
                <i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
                <span>{{message.message}}</span>
            </div>
            <!-- <p-button (click)="cd.reject()" label="Edit Vendor"></p-button> -->
        </div>
    </ng-template>
    <ng-template pTemplate="footer" let-message>
        <div style="display: flex; align-items: center; justify-content: flex-end; gap: 8px;">
            <p-button icon="pi pi-times" label="Cancel" severity="secondary" (click)="cd.reject()"></p-button>
            <p-button icon="pi pi-check" label="Create Anyway" (click)="cd.accept()"></p-button>
        </div>
    </ng-template>
</p-confirmDialog>
